export default __webpack_public_path__ + "static/media/bnr2.803c6a23.jpg";